<template>
  <div>
    <el-dialog
        title="商品订单关联业务单"
        :visible.sync="dialogCreate"
        append-to-body
        width="700"
    >
      <sale-order-event-create :sale-order-id="saleOrderId" @created="eventOrderLinked"></sale-order-event-create>
    </el-dialog>

    <el-dialog
        append-to-body
        title="更新业务单服务状态"
        :visible.sync="updateStatus.dialog"
        width="250px"
    >
      <sale-order-event-order-status-update @updated="statusUpdated()" :id="updateStatus.id"
                                            ref="osu"></sale-order-event-order-status-update>
    </el-dialog>

    <div class="btns">
      <el-button @click="handlerLinkOrder" type="primary">关联新业务单</el-button>
    </div>
    <el-table :data="list">
      <el-table-column width="70" prop="eventOrderId" label="业务单ID"/>
      <el-table-column prop="name" label="业务单名称"/>
      <el-table-column prop="templateName" label="业务单模板名称"/>
      <el-table-column prop="isFinish" label="家长端小程序二维码">
        <template v-slot="scope">
          <cloud-img :click-view="true" :url="scope.row.qrcodeM" :img-height="30" :img-width="30"></cloud-img>
        </template>
      </el-table-column>
      <el-table-column prop="isFinish" label="服务状态">
        <template v-slot="scope">
          <el-tag size="mini" type="info" v-if="scope.row.isFinish === 0">未完成</el-tag>
          <el-tag size="mini" type="success" v-else-if="scope.row.isFinish === 1">完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="handlerUpdateStatus(scope.row.id)">更新</el-button>
          <el-button size="mini" type="text" @click="removeItem(scope.row.id)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import SaleOrderEventCreate from "@/components/saleOrder/SaleOrderEventCreate.vue";
import {saleorder} from "@/api/saleorder";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import {mapActions} from "vuex";
import SaleOrderEventOrderStatusUpdate from "@/components/saleOrder/SaleOrderEventOrderStatusUpdate.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import EventOrderList from "@/components/eventorder/EventOrderList.vue";

export default {
  name: 'SaleOrderEventDetail',
  components: {EventOrderList, CloudImg, SaleOrderEventOrderStatusUpdate, SaleOrderEventCreate},
  props: {
    saleOrderId: Number
  },
  data() {
    return {
      list: [],
      dialogCreate: false,

      eventOrderInfo: {},

      updateStatus: {
        dialog: false,
        id: ""
      }
    };
  },

  created() {
    this.getData();
  },

  methods: {
    ...mapActions('saleOrder', ['triggerRefreshSalrOrderList']),

    handlerUpdateStatus(id) {
      this.updateStatus.dialog = true;
      this.updateStatus.id = id;

      var isFinish = this.list.filter(item => {
        return item.id === id;
      })[0].isFinish;

      setTimeout(() => {
        this.$refs.osu.isFinish = isFinish;
      }, 200)
    },

    removeItem(id) {
      this.$confirm("确定删除吗？").then(() => {
        saleorder.deleteEventOrderLink(id).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.triggerRefreshSalrOrderList();
            this.getData();
          }
        })
      }).catch(() => {
      })
    },

    statusUpdated() {
      this.triggerRefreshSalrOrderList();
      this.getData();
      this.updateStatus.dialog = false;
    },

    getData() {
      let loading = this.$loading({text: "加载中..."});
      saleorder.listEventOrder(this.saleOrderId).then(list => {
        loading.close();
        this.list = list;
      })
    },
    handlerLinkOrder() {
      this.dialogCreate = true;
    },

    eventOrderLinked() {
      this.dialogCreate = false;
      this.getData();
    },
  },
};
</script>

<style scoped>
.btns {
  margin-bottom: 12px;
}
</style>
